module.exports = __webpack_public_path__ + "img/customer_design_4.bd7212f.jpg";